import { FormattedMessage } from "react-intl";
import { displayPopin } from "../../Hook/popins";
import { useResolvedMode } from "../../Hook/theme";
import { AdsBannerProps } from "./config";
import AdTile from "./AdTile";

/**
 * Family A, subscription (2d): the indigo → violet → pink gradient survives
 * verbatim in dark; light drops the end-stops in lightness so the white copy
 * keeps its contrast on a bright feed. CTA text stays #7c3aed both ways.
 */
const MODES = {
  dark: "border border-white/40 bg-gradient-to-r from-[#6366f1] via-[#8b5cf6] to-[#ec4899] shadow-[0_18px_40px_rgba(124,58,237,0.4)]",
  light: "border border-white/40 bg-gradient-to-r from-[#4f46e5] via-[#7c3aed] to-[#db2777] shadow-[0_18px_40px_rgba(124,58,237,0.28)]",
};

function SubscriptionBanner({ onDismiss }: AdsBannerProps) {
  const display = displayPopin();
  const mode = useResolvedMode();

  return (
    <AdTile
      testId="ad-subscription"
      onOpen={() => display("subscribe")}
      onDismiss={onDismiss}
      className={MODES[mode]}
    >
      <div className="flex-1 min-w-0">
        <p className="text-[10px] uppercase tracking-[0.35em] text-white/80 truncate">
          <FormattedMessage id="ads_sub_kicker" defaultMessage="VIP access" />
        </p>
        <h3 className="text-lg sm:text-xl font-black leading-tight text-white truncate">
          <FormattedMessage id="ads_sub_title" defaultMessage="Unlock full subscriber perks" />
        </h3>
        <p className="text-xs text-white/90 truncate hidden sm:block">
          <FormattedMessage
            id="ads_sub_body"
            defaultMessage="Get premium access and bonus features today."
          />
        </p>
      </div>
      <div className="flex-none inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-xs sm:text-sm font-bold text-[#7c3aed] shadow-sm whitespace-nowrap">
        <FormattedMessage id="ads_sub_cta" defaultMessage="Go premium" />
        <span aria-hidden>→</span>
      </div>
    </AdTile>
  );
}

export default SubscriptionBanner;
